import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import DebugSelectors from '../../../Modules/Redux/Global/Debug/DebugSelectors';
import VideoStoreActions from '../../../Modules/Redux/Global/Video/VideoStoreActions';
import { LocalVideoSource } from '../../../Modules/VideoSource/LocalVideoSource';
import { IS_DEV } from '../../../Utils/Constants';
import { useShowSidebar } from '../../../Utils/Hooks/UseShowSidebar';
import { ReactComponent } from '../../../Utils/Types';
import { AuthenticatedRoute } from '../Components/AuthenticatedRoute/AuthenticatedRoute';
import { DebugMenu } from '../Components/DebugMenu/DebugMenu';
import { DebugMenuButton } from '../Components/DebugMenuButton/DebugMenuButton';
import { Sidebar } from '../Components/Sidebar/Sidebar';
import { AuthPage } from '../Pages/Auth/AuthPage';
import { CreateMoonListPage } from '../Pages/CreateMoonList/CreateMoonListPage';
import { FeedbackPage } from '../Pages/Feedback/FeedbackPage';
import { HomePage } from '../Pages/Home/HomePage';
import { MoonListPage } from '../Pages/MoonList/MoonListPage';
import { MoonListsPage } from '../Pages/MoonLists/MoonListsPage';
import { StreamPage } from '../Pages/Stream/StreamPage';
import { WidgetPage } from '../Pages/Widget/WidgetPage';

export function AppNavigation(): ReactComponent {
  const showSidebar = useShowSidebar();
  const dispatch = useDispatch();
  const isDebugMode: boolean = useSelector(DebugSelectors.isDebugMode);
  const [isDebugMenuOpen, setIsDebugMenuOpen] = useState(false);

  useEffect(() => {
    if (IS_DEV) {
      dispatch(VideoStoreActions.setVideoSource(new LocalVideoSource('smo.mp4')));
    }
  }, []);

  function openDebugMenu(): void {
    setIsDebugMenuOpen(true);
  }

  function closeDebugMenu(): void {
    setIsDebugMenuOpen(false);
  }

  return (
    <div className="flex">
      {showSidebar ? <Sidebar /> : undefined}
      <div className="w-full bg-bg">
        <Routes>
          <Route path="" element={<HomePage />} />
          <Route
            path="/stream"
            element={
              <AuthenticatedRoute>
                <StreamPage />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="/moon/list/create"
            element={
              <AuthenticatedRoute>
                <CreateMoonListPage />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="/moon/list/:id"
            element={
              <AuthenticatedRoute>
                <MoonListPage />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="/moon/list"
            element={
              <AuthenticatedRoute>
                <MoonListsPage />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <AuthenticatedRoute>
                <FeedbackPage />
              </AuthenticatedRoute>
            }
          />
          <Route path="/widget/:sessionId" element={<WidgetPage />} />
          <Route path="/auth" element={<AuthPage />} />
        </Routes>
      </div>

      {showSidebar && isDebugMode ? (
        <div className="fixed bottom-6 left-6">
          <DebugMenuButton onClick={openDebugMenu} />
        </div>
      ) : undefined}

      {isDebugMenuOpen && showSidebar ? <DebugMenu onClose={closeDebugMenu} /> : undefined}
    </div>
  );
}
